import React from "react";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import { styled } from "@mui/material/styles";
import { Typography, Button } from "@mui/material";
import Footer from "../../Footer/Footer";
import HeaderInternal from "../../Header/HeaderInternal";
import SuccessAppNew from "../../Banners/SuccessAppNew";

/**
 * PM5 T2 (money path, batch "onboarding") — converted from MUI v4 +
 * `makeStyles` to MUI v5+ (`@mui/material`) `styled`/`sx`.
 * See docs/mui-conversion-guide.md.
 *
 * **SUBSCRIPTIONS ESCALATION CLASS.** The post-purchase landing page — what a
 * member sees the moment a membership goes active. Styling-only conversion;
 * this component has no state, no effects and no API calls.
 *
 * DEAD RULES DROPPED (guide §1.2 row 1): `trialHeader`, `playerWrapper`,
 * `player`, `playIcon`, `marginSpacing` and `appBackground` were declared in
 * the v4 `useStyles` object but never referenced from this file's JSX, so they
 * emitted CSS no element carried.
 */

// was: useStyles().playerBackground — a bare <div>, which has no `sx` prop.
const PageBackground = styled("div")(({ theme }) => ({
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(3),
  backgroundColor: theme.palette.background.upgradeBG,
  [theme.breakpoints.up("sm")]: {
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
  },
}));

// was: useStyles().trialTitle
const trialTitleSx = (theme) => ({
  color: theme.palette.background.ffGreen,
  fontSize: "3rem",
  lineHeight: "2.8rem",
  fontWeight: 500,
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(0),
  textAlign: "center",
  [theme.breakpoints.up("sm")]: {
    textAlign: "left",
    fontSize: "3.2rem",
    lineHeight: "3rem",
    marginBottom: theme.spacing(1),
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "4rem",
    lineHeight: "3.8rem",
  },
});

// was: useStyles().trialSubTitle
const trialSubTitleSx = (theme) => ({
  fontSize: "1.4rem",
  textAlign: "center",
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(3),
  [theme.breakpoints.up("sm")]: {
    textAlign: "left",
    fontSize: "1.8rem",
    lineHeight: "2rem",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "2.4rem",
    lineHeight: "2.6rem",
  },
});

// was: useStyles().bodyText
const bodyTextSx = {
  "& a": {
    color: "#fff",
  },
};

// was: useStyles().dashboardButton, plus a v4 default that has to be restored.
//
// PARITY RESTORE (guide §2, "Button default color"): `color: "text.primary"`
// is NOT in the v4 rule. This `<Button>` carries no `color` prop, so v4
// rendered it `color="default"` → `color: theme.palette.text.primary`. v5+
// made `primary` the default — #99ca3c, the same lime `themeV5`'s
// `MuiButton.root` paints as the button's background — so without this pin the
// "Get Started Now" label would be invisible.
const dashboardButtonSx = (theme) => ({
  width: "100%",
  margin: "20px 0 0 0",
  padding: "12px 20px",
  [theme.breakpoints.up("sm")]: {
    width: "auto",
    padding: "12px 30px",
  },
  [theme.breakpoints.up("md")]: {
    width: "auto",
    padding: "12px 30px",
  },
  color: "text.primary",
});

export default function Success() {
  return (
    <div>
      <HeaderInternal />
      <PageBackground>
        <Container fixed fixedcomponent="main" maxWidth="md">
          <Grid container>
            <Grid size={{ xs: 12, sm: 12, md: 12 }}>
              <Typography component="h1" variant="h1" sx={trialTitleSx}>
                Woo Hoo!
              </Typography>
              <Typography component="h2" variant="h2" sx={trialSubTitleSx}>
                Welcome to FarmFLiX!
              </Typography>
              <Typography variant="body2" sx={bodyTextSx}>
                Your FarmFLiX Membership is now active - get stuck in and enjoy
                our content.
              </Typography>
              <br />
              <Typography variant="body2" sx={bodyTextSx}>
                Feel free to reach out to us with questions at anytime! Right
                now, have a browse through out back catalogue, or why not
                install our new App and browse from your mobile device.
              </Typography>
              <br />
              <Typography variant="body2" sx={bodyTextSx}>
                Enjoy,
              </Typography>
              <Typography variant="body2" sx={bodyTextSx}>
                <b>John &amp; The FarmFLiX Crew</b>
              </Typography>
              <a href="/videos" style={{ textDecoration: "none" }}>
                <Button name="get-started" sx={dashboardButtonSx} size="medium">
                  Get Started Now
                </Button>
              </a>
              <Typography
                variant="body2"
                sx={bodyTextSx}
                style={{ marginTop: "16px" }}
              >
                <b>We&apos;re here to help!</b>
                <br />
                If you have any questions or issues, simply use our Help Widget
                on this page or contact us at{" "}
                <a href="mailto:info@farmflix.tv">info@farmflix.tv</a>
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </PageBackground>
      <SuccessAppNew />
      <Footer />
    </div>
  );
}
